import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfigService } from 'src/app/core/service/config.service';
import { IncreasePriceComponent } from './increase-price/increase-price.component';
import * as moment from 'moment';

@Component({
  selector: 'app-reserve-price',
  templateUrl: './reserve-price.component.html',
  styleUrls: ['./reserve-price.component.css']
})
export class ReservePriceComponent implements OnInit {
  @Input() auctionData: any;
  @Input() number: any;
  raisePrice: any;
  loading = false;
  @Input() myBlanace: any;
  dataConfirmActions: any;
  countdownEndTime!: moment.Moment;
  minutesRemaining!: number;
  progressWidth!: string;
  @Input() startDateTimer: any;
  @Input() endDateTimer: any;
  @Output() reloadPage = new EventEmitter<any>();
  showIncrease = true;
  constructor(
    private dialog: MatDialog,
    public _config: ConfigService,
  ) {

  }

  ngOnInit() {
    this.raisePrice = Number(this.auctionData.reserve_price) - Number(this.number);
    if (this.auctionData?.is_reserve) {
      this.checkShowIncrease();
    }

    //  // set the countdown end time
    //  this.countdownEndTime = moment().add(1, 'hours').add(59, 'minutes').add(43, 'seconds');

    //  // update the countdown every second
    //  setInterval(() => {
    //    // calculate the time remaining
    //    const timeRemaining = this.countdownEndTime.diff(moment());

    //    // check if the countdown has ended
    //    if (timeRemaining <= 0) {
    //      this.minutesRemaining = 0;
    //      return;
    //    }

    //    // calculate the minutes remaining using Moment.js
    //    const duration = moment.duration(timeRemaining);
    //    const minutes = Math.floor(duration.asMinutes());

    //    // update the minutes remaining property
    //    this.minutesRemaining = minutes;
    //  }, 1000);
  }

  ngOnChanges(changes: any): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    // debugger
    if (changes.number) {
      this.raisePrice = Number(this.auctionData.reserve_price) - Number(changes.number.currentValue);

    }
  }
  checkShowIncrease() {
    const currentTime = moment().unix();
    const fiveMinutesAgo = moment(this.endDateTimer).subtract(5, 'minutes').unix();
    setInterval(() => {
      const currentTime = moment().unix();
      const fiveMinutesAgo = moment(this.endDateTimer).subtract(5, 'minutes').unix();


      if (currentTime > fiveMinutesAgo) {
        this.showIncrease = true;
      }
    }, 500);
  }

  increasePrice() {
    this.dataConfirmActions = {
      title: this._config.translate.instant("Auction Item.Start Auction"),
      icon: 'warning',
      text: this._config.translate.instant("Auction Item.AreYouSureStart"),
      confirm: this._config.translate.instant("actions.confirm"),
      cancel: this._config.translate.instant("actions.cancel"),
      auctionId: this.auctionData.id,
      raisePrice: this.raisePrice,
      myBlanace: this.myBlanace,
      number: this.number,
      auctionData: this.auctionData
    };

    const dialogRef = this.dialog.open(IncreasePriceComponent, {
      data: this.dataConfirmActions,
      panelClass: 'customDialogStyle',
      maxWidth: '540px'
    });

    dialogRef.afterClosed().subscribe((res) => {


      if (res == 'success') {
        this.reloadPage.emit();
      }


    });

  }

}
